/**
 * wdg_make_google_ads_responsive
 * Make Google Ads responsive on single. Post
 */
export function wdg_make_google_ads_responsive() {
    jQuery('iframe[id^="google_ads_iframe_"]').each(function () {
        let adIframeEl = jQuery(this);
        let adIframeElContents;

        try {
            adIframeElContents = adIframeEl.contents();
        } catch (e) {
            // If iframe is cross-origin, skip it
            return;
        }

        let frameHeight = adIframeEl.attr('height');
        let frameWidth = adIframeEl.attr('width');
        adIframeEl.css({
            "width": '100%', 'height': 'auto', "aspect-ratio": frameWidth + "/" + frameHeight
        });

        adIframeElContents.find('#google_image_div').css("position", 'relative');
        adIframeElContents.find('img').css({
            "width": '100%', 'height': 'auto',
        });
    });
}

/**
 * wdg_check_is_iamagazine_post_page
 * Check if current page belong to iamagazine & single post display page
 */
export function wdg_check_is_iamagazine_post_page() {
    let pagePath = window.location.pathname.split('/');
    let is_single_post = jQuery("body").hasClass('single');
    if (typeof pagePath != "undefined" && pagePath.length) {
        if ((typeof pagePath[1] != "" && pagePath[1] && pagePath[1] == "iamagazine") && is_single_post) {
            return true;
        }
    }
    return false;
}

// Observe DOM changes
const wdg_google_ads_observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Check if any added node is or contains a matching iframe
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    const $node = jQuery(node);
                    if ($node.is('iframe[id^="google_ads_iframe_"]') || $node.find('iframe[id^="google_ads_iframe_"]').length) {
                        wdg_make_google_ads_responsive();
                    }
                }
            });
        }
    }
});

// Initial call in case some iframes are already present
document.addEventListener('DOMContentLoaded', () => {
    wdg_google_ads_observer.observe(document.body, {childList: true, subtree: true});
});

